var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostbuddyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.84L1.59998 14.9333L3.30664 16.32L16 6.72L28.6933 16.32L30.4 14.9333L16 3.84ZM5.75998 16.1067L16 8.32L26.24 16.1067V24.4267H24.32L25.4933 27.3067L24.2133 27.9467L20.16 24.4267H5.75998V16.1067ZM20.48 15.5733C20.48 16.2803 19.9069 16.8533 19.2 16.8533C18.493 16.8533 17.92 16.2803 17.92 15.5733C17.92 14.8664 18.493 14.2933 19.2 14.2933C19.9069 14.2933 20.48 14.8664 20.48 15.5733ZM12.8 16.8533C13.5069 16.8533 14.08 16.2803 14.08 15.5733C14.08 14.8664 13.5069 14.2933 12.8 14.2933C12.093 14.2933 11.52 14.8664 11.52 15.5733C11.52 16.2803 12.093 16.8533 12.8 16.8533ZM19.4426 19.0452C19.8085 19.1364 20.036 19.5101 19.8877 19.8567C19.608 20.5102 19.1679 21.087 18.6036 21.5311C17.8595 22.1167 16.9417 22.4381 15.9949 22.4447C15.048 22.4513 14.1258 22.1427 13.3736 21.5676C12.8032 21.1315 12.3551 20.5609 12.0663 19.9113C11.9131 19.5668 12.1355 19.1899 12.5 19.0936C12.8645 18.9973 13.2314 19.2208 13.4101 19.5528C13.6041 19.9134 13.8735 20.2311 14.2029 20.483C14.7144 20.874 15.3415 21.0839 15.9853 21.0794C16.6292 21.0749 17.2533 20.8563 17.7593 20.4581C18.0851 20.2017 18.3501 19.8802 18.539 19.517C18.713 19.1825 19.0768 18.9539 19.4426 19.0452Z",
    fill: "url(#paint0_linear_585_2811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_585_2811",
    x1: 16,
    y1: 3.84,
    x2: 16,
    y2: 27.9467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FA8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#1155C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostbuddyIcon);
export default __webpack_public_path__ + "static/media/hostbuddy_icon.02f100750470c4293cd57c00824eeeb9.svg";
export { ForwardRef as ReactComponent };